import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-35">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-36">
        <Link to="/" className="text-xl font-bold text-gray-800 flex items-center" data-id="element-37">
          <span className="text-[#0FB9B1]" data-id="element-38">Aakash</span>&nbsp;Gupta
        </Link>
        {/* Mobile menu button */}
        <button className="md:hidden" onClick={toggleMenu} data-id="element-39">
          {isMenuOpen ? <XIcon size={24} data-id="element-40" /> : <MenuIcon size={24} data-id="element-41" />}
        </button>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-42">
          <div className="relative group" data-id="element-43">
            <Link to="#" className={`font-medium ${location.pathname.includes('/portfolio') ? 'text-[#0FB9B1]' : 'text-gray-700 hover:text-[#0FB9B1]'}`} data-id="element-44">
              Portfolio
            </Link>
            <div className="absolute hidden group-hover:block bg-white shadow-md mt-2 py-2 rounded-md w-40 z-10" data-id="element-45">
              <Link to="/portfolio/apollo" className="block px-4 py-2 text-gray-700 hover:bg-gray-100" data-id="element-46">
                Apollo.io
              </Link>
              <Link to="/portfolio/affirm" className="block px-4 py-2 text-gray-700 hover:bg-gray-100" data-id="element-47">
                Affirm
              </Link>
              <Link to="/portfolio/epic-games" className="block px-4 py-2 text-gray-700 hover:bg-gray-100" data-id="element-48">
                Epic Games
              </Link>
              <Link to="/portfolio/thredup" className="block px-4 py-2 text-gray-700 hover:bg-gray-100" data-id="element-49">
                ThredUp
              </Link>
              <Link to="/portfolio/rap-to-beats" className="block px-4 py-2 text-gray-700 hover:bg-gray-100" data-id="element-50">
                Rap to Beats
              </Link>
              <Link to="/portfolio/scoutforce" className="block px-4 py-2 text-gray-700 hover:bg-gray-100" data-id="element-51">
                ScoutForce
              </Link>
            </div>
          </div>
          <Link to="/my-story" className={`font-medium ${location.pathname === '/my-story' ? 'text-[#0FB9B1]' : 'text-gray-700 hover:text-[#0FB9B1]'}`} data-id="element-52">
            My Story
          </Link>
          <Link to="https://www.news.aakashg.com/" className={`font-medium text-gray-700 hover:text-[#0FB9B1]`} target="_blank" rel="noopener noreferrer" data-id="element-53">
            Newsletter
          </Link>
          <Link to="https://www.aakashg.com/blog/" className={`font-medium text-gray-700 hover:text-[#0FB9B1]`} target="_blank" rel="noopener noreferrer" data-id="element-54">
            Blog
          </Link>
          <Link to="https://www.news.aakashg.com/s/product-growth-podcast" className={`font-medium text-gray-700 hover:text-[#0FB9B1]`} target="_blank" rel="noopener noreferrer" data-id="element-55">
            Podcast
          </Link>
          <Link to="/socials" className={`font-medium ${location.pathname === '/socials' ? 'text-[#0FB9B1]' : 'text-gray-700 hover:text-[#0FB9B1]'}`} data-id="element-56">
            Socials
          </Link>
        </nav>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-md" data-id="element-57">
          <div className="container mx-auto px-4 py-2 flex flex-col space-y-4" data-id="element-58">
            <div className="py-2" data-id="element-59">
              <p className="font-medium text-gray-700 mb-2" data-id="element-60">Portfolio</p>
              <div className="pl-4 space-y-2" data-id="element-61">
                <Link to="/portfolio/apollo" className={`block py-1 ${location.pathname === '/portfolio/apollo' ? 'text-[#0FB9B1]' : 'text-gray-600'}`} onClick={toggleMenu} data-id="element-62">
                  Apollo.io
                </Link>
                <Link to="/portfolio/affirm" className={`block py-1 ${location.pathname === '/portfolio/affirm' ? 'text-[#0FB9B1]' : 'text-gray-600'}`} onClick={toggleMenu} data-id="element-63">
                  Affirm
                </Link>
                <Link to="/portfolio/epic-games" className={`block py-1 ${location.pathname === '/portfolio/epic-games' ? 'text-[#0FB9B1]' : 'text-gray-600'}`} onClick={toggleMenu} data-id="element-64">
                  Epic Games
                </Link>
                <Link to="/portfolio/thredup" className={`block py-1 ${location.pathname === '/portfolio/thredup' ? 'text-[#0FB9B1]' : 'text-gray-600'}`} onClick={toggleMenu} data-id="element-65">
                  ThredUp
                </Link>
                <Link to="/portfolio/rap-to-beats" className={`block py-1 ${location.pathname === '/portfolio/rap-to-beats' ? 'text-[#0FB9B1]' : 'text-gray-600'}`} onClick={toggleMenu} data-id="element-66">
                  Rap to Beats
                </Link>
                <Link to="/portfolio/scoutforce" className={`block py-1 ${location.pathname === '/portfolio/scoutforce' ? 'text-[#0FB9B1]' : 'text-gray-600'}`} onClick={toggleMenu} data-id="element-67">
                  ScoutForce
                </Link>
              </div>
            </div>
            <Link to="/my-story" className={`py-2 font-medium ${location.pathname === '/my-story' ? 'text-[#0FB9B1]' : 'text-gray-700'}`} onClick={toggleMenu} data-id="element-68">
              My Story
            </Link>
            <Link to="https://www.news.aakashg.com/" className="py-2 font-medium text-gray-700" onClick={toggleMenu} target="_blank" rel="noopener noreferrer" data-id="element-69">
              Newsletter
            </Link>
            <Link to="https://www.aakashg.com/blog/" className="py-2 font-medium text-gray-700" onClick={toggleMenu} target="_blank" rel="noopener noreferrer" data-id="element-70">
              Blog
            </Link>
            <Link to="https://www.news.aakashg.com/s/product-growth-podcast" className="py-2 font-medium text-gray-700" onClick={toggleMenu} target="_blank" rel="noopener noreferrer" data-id="element-71">
              Podcast
            </Link>
            <Link to="/socials" className={`py-2 font-medium ${location.pathname === '/socials' ? 'text-[#0FB9B1]' : 'text-gray-700'}`} onClick={toggleMenu} data-id="element-72">
              Socials
            </Link>
          </div>
        </div>}
    </header>;
};
export default Header;